import React, { useEffect, useState } from 'react';

import { Loader, Select, SelectProps } from '@mantine/core';
import useFlowTriggerList from 'hooks/flows/useFlowTriggerList';

type FlowTriggerSelectProps = Omit<SelectProps, 'data' | 'rightSection'>;

const FlowTriggerSelect = ({ ...selectProps }: FlowTriggerSelectProps): JSX.Element => {
  const { data, isSuccess, isLoading } = useFlowTriggerList();

  const [options, setOptions] = useState<string[]>([]);

  const disabled = selectProps.disabled || isLoading;
  const rightSection = isLoading ? <Loader /> : undefined;

  useEffect(() => {
    if (isSuccess && data?.data) {
      setOptions([...data.data.immediateAndDelayedTriggerList, ...data.data.reminderTriggerList]);
    }
  }, [isSuccess, data]);

  return <Select data={options} disabled={disabled} rightSection={rightSection} {...selectProps} />;
};

export default FlowTriggerSelect;
